import React from 'react';
import styled, { css } from 'styled-components';
import { Carousel, CarouselItem, CarouselIndicators } from 'reactstrap';
// CustomEvent polyfill for IE9+ for the carousel on the visitors homepage
// Reactstrap issue: https://github.com/reactstrap/reactstrap/issues/799
import 'custom-event-polyfill';

const Positioning = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({theme}) => theme.colorBlack};

  ::after {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.35);
    z-index: 1;
  }
`;

const StyledCarousel = styled(Carousel)`
  ${Positioning};

  .carousel-indicators {
    display: none;
  }

  .carousel-inner {
    position: absolute;
    height: 100%;
  }
`;

const StyledCarouselItem = styled(CarouselItem)`
  height: 100%;
`;

const BgImg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const MobileFallbackImage = styled.div`
  ${Positioning};
  background-image: url('https://images.hu-production.be/static/img/home/HUhomepage-mobile-1178-876.jpg');
  background-size: cover;
  background-position: center;
`;

const items = [
  {
    src: 'https://images.hu-production.be/static/img/home/HUhomepage.jpg',
  },
  {
    src: 'https://images.hu-production.be/static/img/home/homepage2.jpg',
  },
  {
    src: 'https://images.hu-production.be/static/img/home/homepage3.jpg',
    bgPosition: 'center top',
  },
];

class ReactstrapCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      isMobile: true,
    };
  }

  componentDidMount() {
    if (window.innerWidth > 768) {
      this.setState({ isMobile: false });
    }
  }

  onExiting = () => {
    this.animating = true;
  }

  onExited = () => {
    this.animating = false;
  }

  next = () => {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous = () => {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex = (newIndex) => {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex, isMobile } = this.state;

    return (
      isMobile
      ? <MobileFallbackImage />
      : (
        <StyledCarousel
          activeIndex={activeIndex}
          className="carousel-fade"
          interval={3000}
          next={this.next}
          previous={this.previous}
          ride="carousel"
        >
          <CarouselIndicators
            activeIndex={activeIndex}
            items={items}
            onClickHandler={this.goToIndex}
          />

          { items.map((item) => (
            <StyledCarouselItem
              key={item.src}
              onExited={this.onExited}
              onExiting={this.onExiting}
            >
              <BgImg style={{ backgroundImage: `url(${item.src})`, backgroundPosition: item.bgPosition }} />
            </StyledCarouselItem>
          ))}
        </StyledCarousel>
      )
    );
  }
}

export default ReactstrapCarousel;
